export const MIN_SEARCH_TEXT_LENGTH = 2;
